module.exports = __webpack_public_path__ + "static/media/stamp-light.947f84c5.svg";